<template>
  <e-charts
    ref="line"
    autoresize
    :options="line"
    theme="theme-color"
    auto-resize
    class="w-100"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/markArea'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/dataZoom'

import theme from '../../../../../libs/charts/echart/theme.json'
import i18n from '../../../../../i18n/i18n'
ECharts.registerTheme('theme-color', theme)

const colors = ['#ff9f44', '#32b154']

export default {
  name:'weight-chart',
  components: {
    ECharts
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      weightData: {},
      line: {
        colorBy: 'series',
        color: colors,
        grid: {
          left: '65px',
          right: '30px',
          bottom: '60px',
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#f2f2f2',
          textStyle: {
            color: '#666'
          }
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
              title: {
                zoom: i18n.t('echarts.toolbox.Zoom'),
                back: i18n.t('echarts.toolbox.ZoomReset')
              }
            },
            restore: {
              title: i18n.t('echarts.toolbox.Restore')
            },
            saveAsImage: {
              title: i18n.t('echarts.toolbox.SaveAsImage'),
              type: 'jpg',
              backgroundColor: '#fff',
              pixelRatio: 5
            }
          }
        },
        legend: {
          top: 'bottom',
          padding: 0
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: i18n.t('hives.detail.charts.titles.ExternalTemperature', { p: '(kg)' }),
            type: 'line',
            showSymbol: false,
            data: []
          }
        ]
      }
    }
  },
  watch: {
    chartData: {
      immediate: true,
      handler () {
        this.weightData = this.chartData
      }
    }
  },
  mounted () {}
}
</script>